/**
 * Chart utilities for overview charts. S-curve series building (moved from helpers).
 */

import type { SCurveCumulativePoint } from '@/types/analyticsApi';

/** Build xAxisData and two series from planned/actual cumulative arrays (dates may differ). */
export function buildScurveSeries(
  planned: SCurveCumulativePoint[] | undefined,
  actual: Array<{ date?: string | null; cumulative?: number }> | undefined,
  plannedLabel: string,
  actualLabel: string
): { xAxisData: string[]; series: { name: string; data: number[] }[] } {
  const plannedArr = planned ?? [];
  const actualArr = actual ?? [];
  const allDates = [...new Set([
    ...plannedArr.map((p) => p.date).filter(Boolean),
    ...actualArr.map((a) => a.date).filter(Boolean),
  ])] as string[];
  allDates.sort();
  if (allDates.length === 0) return { xAxisData: [], series: [] };
  let lastPlanned = 0;
  let lastActual = 0;
  const plannedData = allDates.map((d) => {
    const p = plannedArr.find((x) => x.date === d);
    if (p != null && typeof p.cumulative === 'number') { lastPlanned = p.cumulative; return p.cumulative; }
    return lastPlanned;
  });
  const actualData = allDates.map((d) => {
    const a = actualArr.find((x) => x.date === d);
    if (a != null && typeof a.cumulative === 'number') { lastActual = a.cumulative; return a.cumulative; }
    return lastActual;
  });
  return {
    xAxisData: allDates,
    series: [
      { name: plannedLabel, data: plannedData },
      { name: actualLabel, data: actualData },
    ],
  };
}
